import { matchPath } from 'react-router-dom';

import { setStudentClassInfo } from 'approot/shared/api/auth/student-user-auth';
import type { GetStudentQuery } from '../../../students/students.graphql.generated';
import { PRIVATE_CLASS } from 'global/private-routes.constants';
import { regionDataVar } from 'approot/shared/region/region.apollo';
import type { Pluck } from 'lib/gql/pluck';

export function setStudentClassFromUrl(
  studentClasses: Pluck<GetStudentQuery, 'getStudent.currentClasses'>[]
): void {
  const { region } = regionDataVar();
  const pathWithRegion = `/${region}${PRIVATE_CLASS}`;
  let match = matchPath(pathWithRegion, window.location.pathname);

  if (!match) {
    match = matchPath(PRIVATE_CLASS, window.location.pathname);
  }

  if (match) {
    const classId = match.params.classId;
    if (classId) {
      const studentClass = studentClasses.find(c => {
        return c.classToDoId === classId;
      });
      if (studentClass) {
        setStudentClassInfo({
          classId: studentClass.id,
          classToDoId: classId,
        });
      }
    }
  }
}
